export enum ChatMessageFromEnum {
  ME = 'from-me',
  THEM = 'from-them',
}
